(() => {
    let modals;
    let closes;

    run();

    function run() {
        setTimeout(initModalBtn, 1000);
        initModalClose();

        setModal();

        window.addEventListener("popstate", function (e) {
            setModal();
        });
    }

    function initModalClose() {
        closes = document.querySelectorAll(".js-modal__close");

        if (!closes) {
            return;
        }

        closes.forEach(el => {
            el.addEventListener("click", e => {
                pushHistory(" ");
                setModal();
            });
        });
       
       
    }

    function initModalBtn() {
        modals = document.querySelectorAll(".js-button-modal");

        if (!modals) {
            return;
        }

        modals.forEach((el) => {
            el.addEventListener("click", function (el) {
                pushHistory("#"+this.dataset.target);
                setModal();
            });
        });
    }

    function pushHistory(hash){
        if (history.pushState) {
            history.pushState(null, null, hash);
        }
    }

    function setModal(){
       
        if (window.location.hash && window.location.hash.includes("modal")) {
           showModal();
        } else {
            hideModal();
        }
    }

    function showModal(){
        let hash = window.location.hash.substring(1);
        let modal = document.getElementById(hash);      
        modal.classList.add("active");

            if (modal.classList.contains("active")) {
                document.body.style.overflow = "hidden";
            }
    }

    function hideModal(){

        let modals = document.querySelectorAll(".modal");

        modals.forEach((el) => {
            el.classList.remove("active");

            if (!el.classList.contains("active")) {
                document.body.style.overflow = "auto";
            }
        });

        
    }

})();
